<section class="tm-automation" aria-labelledby="tm-automation-heading">
  <header class="tm-automation__header">
    <mat-icon class="tm-automation__header-icon" aria-hidden="true">settings</mat-icon>
    <h3 id="tm-automation-heading" class="tm-automation__title">
      {{ 'modules.form.automation.blockTitle' | translate }}
    </h3>
  </header>

  <div class="tm-automation__field">
    <div id="tm-automation-id-label" class="tm-automation__label">
      {{ 'modules.form.automation.idLabel' | translate }}
    </div>

    @if (automationKey(); as key) {
      <div class="tm-automation__id-row">
        <code class="tm-automation__id" aria-labelledby="tm-automation-id-label">{{ key }}</code>
        <button
          type="button"
          class="tm-automation__copy"
          (click)="copyKey()"
          [attr.aria-label]="'modules.form.automation.copy' | translate"
        >
          <mat-icon class="tm-automation__copy-icon" aria-hidden="true">
            {{ copied() ? 'check' : 'content_copy' }}
          </mat-icon>
          {{ (copied() ? 'modules.form.automation.copied' : 'modules.form.automation.copy') | translate }}
        </button>
      </div>
      <p class="tm-automation__hint">{{ 'modules.form.automation.idHint' | translate }}</p>
    } @else {
      <p class="tm-automation__hint tm-automation__hint--pending">
        {{ 'modules.form.automation.idPending' | translate }}
      </p>
    }
  </div>

  <div class="tm-automation__field">
    <div id="tm-automation-status-label" class="tm-automation__label">
      {{ 'modules.form.automation.statusLabel' | translate }}
    </div>
    <div class="tm-automation__status" role="group" aria-labelledby="tm-automation-status-label">
      @for (option of statusOptions; track option.value) {
        <button
          type="button"
          class="tm-automation__status-btn tm-automation__status-btn--{{ option.modifier }}"
          [class.tm-automation__status-btn--active]="status() === option.value"
          [attr.aria-pressed]="status() === option.value"
          [disabled]="readOnly()"
          (click)="selectStatus(option.value)"
        >
          <span class="tm-automation__dot" aria-hidden="true"></span>
          {{ option.labelKey | translate }}
        </button>
      }
    </div>
  </div>

  <div class="tm-automation__field">
    <mat-form-field
      appearance="outline"
      floatLabel="always"
      class="tm-automation__select-field tm-automation__field--uppercase-label"
    >
      <mat-label>{{ 'modules.form.automation.frameworkLabel' | translate }}</mat-label>
      <mat-select [formControl]="frameworkControl()">
        <mat-option [value]="null">{{ 'modules.form.automation.frameworkNone' | translate }}</mat-option>
        @for (opt of frameworkOptions; track opt.value) {
          <mat-option [value]="opt.value">{{ opt.labelKey | translate }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
</section>
